import { FC, useCallback, useEffect, useState } from 'react';
import { ThemeProps } from '../../theme/UiThemeProvider'
import { Box, BoxProps } from '../Box'
import { Image, ImageProps } from '../Image'
import { Text, TextProps } from '../Text'

interface AvtaarProps {
  hide?: boolean
  source: string
  title?: string
  fontFamily?: string
  type?: keyof typeof AvtaarTypes
}

export const AvtaarTypes = {
  huge: 'huge',
  large: 'large',
  small: 'small',
  medium: 'medium',
}

export const Avtaar: FC<AvtaarProps> = (props) => {
  const { hide = false, source, title, type = 'huge', fontFamily } = props

  const [showPlaceHolder, setShowPlaceHolder] = useState(true)
  useEffect(() => {
    setShowPlaceHolder(!source || source === '')
  }, [source])

  const onError = useCallback(() => {
    setShowPlaceHolder(true)
  }, [])
  if (hide) {
    return null
  }

  const titleCharacter = title && title.length > 0 ? title?.charAt(0).toUpperCase() : ' '
  return (
    <Box {...styles[type].containerLogo}>
      {!showPlaceHolder && <Image {...styles[type].logo} source={source} resizeMode="center" onError={onError} />}
      {showPlaceHolder && (
        <Box {...styles[type].placeHolderContainer}>
          <Text {...styles[type].placeHolderText} fontFamily={fontFamily}>
            {titleCharacter}
          </Text>
        </Box>
      )}
    </Box>
  )
}

const defaultStyles = {
  topContainerStyle: {
    alignContent: 'center',
    justifyContent: 'center',
  } as BoxProps,
  topTextStyle: {
    fontSize: 'FONT_SIZE_LARGE_PLUS',
    fontWeight: 'FONT_WEIGHT_MEDIUM',
    textAlign: 'center',
    color: 'BLACK_75',
  } as ThemeProps,
  containerLogo: {
    alignContent: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    height: 72,
    width: 72,
    // borderColor: 'GREY_SEPARATOR',
    // backgroundColor: 'WHITE',
    //  borderWidth: 1,
    // borderRadius: 72 / 2,
    overflow: 'hidden',
  } as BoxProps,
  logo: {
    height: 72,
    width: 72,
  } as ImageProps,
  placeHolderText: {
    color: 'WHITE',
    fontWeight: 'FONT_WEIGHT_LIGHT',
    fontSize: 'FONT_SIZE_2_EXTRA_LARGE',
  } as TextProps,
  placeHolderContainer: {
    height: '100%',
    width: '100%',
    backgroundColor: 'PRIMARY',
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
}

const styles = {
  huge: {
    ...defaultStyles,
  },
  small: {
    ...defaultStyles,
    containerLogo: {
      ...defaultStyles.containerLogo,
      height: 24,
      width: 24,
      borderRadius: 24 / 2,
    } as BoxProps,
    logo: {
      height: 24,
      width: 24,
    } as ImageProps,
    placeHolderText: {
      color: 'WHITE',
      fontWeight: 'FONT_WEIGHT_LIGHT',
      fontSize: 'FONT_SIZE_TINY',
    } as TextProps,
  },
  medium: {
    ...defaultStyles,
    containerLogo: {
      ...defaultStyles.containerLogo,
      height: 36,
      width: 36,
      // borderRadius: 36 / 2,
    } as BoxProps,
    logo: {
      height: 36,
      width: 36,
    } as ImageProps,
    placeHolderText: {
      color: 'WHITE',
      fontWeight: 'FONT_WEIGHT_LIGHT',
      fontSize: 'FONT_SIZE_MEDIUM',
    } as TextProps,
  },
  large: {
    ...defaultStyles,
    containerLogo: {
      ...defaultStyles.containerLogo,
      height: 54,
      width: 54,
      borderRadius: 54 / 2,
    } as BoxProps,
    logo: {
      height: 54,
      width: 54,
    } as ImageProps,
    placeHolderText: {
      color: 'WHITE',
      fontWeight: 'FONT_WEIGHT_LIGHT',
      fontSize: 'FONT_SIZE_LARGE_3P',
    } as TextProps,
  },
}
